import API from "./api";
import ExportHelper from "./exportHelper";

const PaymentService = {
  // Get my transactions (for student)
  getMyTransactions: async () => {
    try {
      const response = await API.get("/student/transactions");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Export transactions with filters
  exportTransactions: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      params.append('type', 'transactions');
      
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      if (filters.student_id) params.append('student_id', filters.student_id);
      
      const response = await API.get(`/export?${params.toString()}`, {
        responseType: 'blob'
      });
      
      const filename = filters.student_id 
        ? `student_${filters.student_id}_transactions.csv`
        : 'transactions_export.csv';
      
      return ExportHelper.downloadFile(response, filename);
    } catch (error) {
      console.error('Export error:', error);
      throw error;
    }
  }
};

export default PaymentService;